<template>
  <div
    class="d-column reports-turn-filter"
    data-tst="reports_turn_filter_cards"
  >
    <div class="d-flex">
      <div class="d-flex mb-4">
        <div class="d-flex">
          <PokerCard
            v-for="(card, idx) in l_hand"
            :key="`${card}_${idx}`"
            :card="card"
            class="poker-card_selectable"
            :size="screen_max440 ? 'semi-large' : cardSize"
            @click.stop
            @click="switchCard(card)"
          ></PokerCard>
        </div>
        <div
          class="ml-2 mdi mdi-close icon_btn text-semi-large my-auto pa-1 csst csst_nm text-nowrap"
          :class="{
            'opacity_4 no-events': !$store.getters.rep_turn_filterHand,
          }"
          @click.stop="reset"
        >
          <div
            class="csst_content"
            style="position: absolute; bottom: -1.5rem"
            v-html="$t('common.clear_hand')"
          ></div>
        </div>
      </div>
      <!-- <div class="csst mr-auto" style="z-index: 3">
        <div class="clr-grey weight_500 uppercase d-flex mb-1">
          <i small color="grey" class="ml-2 mdi-help-circle-outline mdi"></i>
        </div>
        <div class="csst_content" style="width: 240px">
          {{ $t('tooltips.turn_hand') }}
        </div>
      </div> -->
    </div>
    <div class="cards-rows">
      <div
        v-for="(cardRow, idx) in cardRows"
        :key="idx"
        class="pack-row"
      >
        <PokerCard
          v-for="card in cardRow"
          :key="card"
          :selected="l_hand.some(id => id === card)"
          :selectedBordered="true"
          :card="card"
          class="poker-card_selectable"
          :class="[
            {
              'no-events opacity_4': flopBoard?.includes(card),
            },
          ]"
          :size="screen_max440 ? 'semi-large' : cardSize"
          @click.stop
          @click="switchCard(card)"
        ></PokerCard>
      </div>
    </div>

    <!-- <portal to="turn_filter_dialog_actions">
      <v-btn class="ml-auto" @click="reset">
        {{ $t('btn.clear_all') }}
      </v-btn>
      <v-btn
        class="ml-2"
        color="primary"
        :disabled="!canApply"
        @click="apply()"
      >
        {{ $t('btn.confirm') }}
      </v-btn>
    </portal> -->
  </div>
</template>

<script>
import PokerCard from '@/components/Poker/PokerCard/PokerCard'
import format_mix from '@/mixins/format_mix'
import { getCardRows, getCardsFromStr } from '@/helpers/cards'

export default {
  name: 'ReportsTurnFilter',
  components: {
    PokerCard,
  },
  mixins: [format_mix],
  props: {
    cardSize: { default: () => 'large' },
    instaApply: { default: () => false },
    flopBoard: String,
    turnFilterHand: String,
  },
  data() {
    return {
      colors: ['s', 'h', 'd', 'c'],
      l_hand: ['Ee', `Ee`],
      activeCard: '',
    }
  },
  created() {
    this.inicialize()
  },
  methods: {
    inicialize() {
      this.l_hand = JSON.parse(JSON.stringify(this.turnHand))
      this.activeCard = this.l_hand[0]
    },
    reset() {
      this.activeCard = ''
      this.l_hand = ['Ee', `Ee`]
      if (this.instaApply) {
        this.apply()
      }
    },
    switchCard(card) {
      const res = JSON.parse(JSON.stringify(this.l_hand))
      const switchIndex = res.findIndex(id => id === card)
      if (switchIndex !== -1) {
        res[switchIndex] = `Ee`
        this.l_hand = res
        this.activeCard = ''
        if (this.instaApply) {
          this.apply()
        }
        return
      }
      let idx = res.findIndex(c => c.includes('E'))
      if (idx !== -1) {
        res[idx] = card
      } else {
        idx = res.findIndex(c => !c.includes(this.activeCard))
        res[idx] = card
      }
      this.activeCard = card
      this.l_hand = res
      if (this.instaApply) {
        this.apply()
      }
    },
    apply() {
      if (!this.canApply) return
      let res = this.l_hand.some(c => c.includes('E')) ? [] : this.l_hand
      res = res.join('')
      this.$store.commit('reports_set', { key: 'turn_filterHand', value: res })
    },
  },
  computed: {
    canApply() {
      return this.l_hand.every(i => i.includes('E')) || this.l_hand.every(i => !i.includes('E'))
    },
    turnHand() {
      const hand = this.turnFilterHand || 'EeEe'
      const res = getCardsFromStr(hand)
      return res
    },
    cardRows() {
      return getCardRows()
    },
    screen_max440() {
      return this.$store.getters.screen_max440
    },
  },
  watch: {
    turnHand(hand) {
      if (!this.turnHand) {
        this.reset()
      } else {
        this.l_hand = hand
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 1023px) {
  .pack-row {
    flex-wrap: wrap;
    margin-bottom: 2px;
  }
}

.pack-row {
  display: flex;
  align-self: flex-start;
  // grid-gap: 2px;
  max-width: 100%;
  .poker-card {
    margin-bottom: 2px;
  }
}
.card-item {
  // background: ;
  width: 2.25rem;
  height: 2.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  border-radius: 50%;

  &:after {
    background-color: currentColor;
    border-radius: 50%;
    content: '';
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    z-index: 1;
    transition: 0.2s;
  }
  &:hover {
    &:after {
      opacity: 0.4;
    }
  }
  &_active {
    &:after {
      opacity: 0.4;
    }
  }
}
.sss {
  // cursor: pointer;
  // display: flex;
  // height: var(--switcher-height);
  // border-radius: 4px;
  // background: var(--clr-black-1);
  // overflow: hidden;
  // &_symbol-container {
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   position: relative;
  //   // width: 54px;
  //   width: 24px;
  // }
  &_svg-symbol {
    width: 1.75rem;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      position: absolute;
      fill: currentColor;
    }
  }
  // &_menu {
  //   padding: 1rem;
  //   background: var(--clr-black-1);

  //   &_option {
  //     cursor: pointer;
  //     font-weight: 500;
  //     padding: 0.25rem 1rem;
  //     border-radius: 0px !important;
  //     &:hover {
  //       // color: var(--clr-primary);
  //     }
  //     &_active {
  //       color: var(--clr-primary);
  //       border-top: solid var(--clr-primary) 1px;
  //     }
  //   }
  // }
}
</style>
